<template>
  <div class="base-select">
<!--    <label :for="name">-->
<!--      {{ label || name }}-->
<!--    </label>-->
    <select @change="handleEntity"
            :id="name"
            class="pointer">
      <option value="" disabled
              :selected="!value">
        select {{ name || label }}
      </option>
      <option v-for="(item, index) in options"
              :key="index"
              :selected="value === item"
              :value="objectKey ? JSON.stringify(item) : item">
        {{ handleItem(item) }}
      </option>
    </select>
  </div>
</template>

<script setup>
  const props = defineProps({
    name: String,
    label: String,
    value: String,
    options: Array,
    objectKey: String
  })

  const emit = defineEmits(['select'])

  function handleItem (item) {
    return props.objectKey ? item[props.objectKey] : item
  }

  function handleEntity (ev) {
    emit('select', {name: props.name, value: props.objectKey ? JSON.parse(ev.target.value) : ev.target.value})
  }
</script>

<style lang="scss">
  .base-select {
    @media only screen and (min-width: 0) {
      select {
        height: 33px;
        padding: 4px 8px;
        border-radius: 4px;
        //border: none;
        option:first-child {
          opacity: 0.5;
        }
      }
    }
  }
</style>